/**
 * Author(s) : Shakthi Priya
 * Purpose : This is a Toggle Button for changing the light and dark mode.
 */
import styles from './ToggleEffect.module.scss';
import sun from '../../assets/images/sun.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useState } from 'react';

const ToggleEffect = (props) => {
  const { handleTheme, theme } = props;
  const [toggleClicked, setToggleClicked] = useState(false);

  return (
    <>
      {theme === 'light' ? (
        <div
          onClick={() => {
            setToggleClicked(true);
            handleTheme();
          }}
          className={styles.toggleEffect}
          id={toggleClicked ? styles.light : ''}>
          <img className={styles.lightMode} src={sun} alt="lightMode"></img>
        </div>
      ) : (
        <div
          onClick={() => {
            setToggleClicked(true);
            handleTheme();
          }}
          className={styles.toggleEffect}
          id={toggleClicked ? styles.dark : ''}>
          <FontAwesomeIcon
            className={styles.darkMode}
            icon={faMoon}></FontAwesomeIcon>
        </div>
      )}
    </>
  );
};

ToggleEffect.propTypes = {
  handleTheme: PropTypes.func,
  theme: PropTypes.string,
};
export default ToggleEffect;
